<template lang="pug">
  div.garbage.defense-update
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :hideDeleteButton="(!!fields.id)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs(
        v-model="tabView"
        :tabs="tabs"
        )
      slot
        e-form(:formValidator="formValidator")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-show="tabView === 'tab1'")
            div.body
              div.col
                e-form-group(
                name="name"
                inputType="input"
                label="Наименование"
                :model="fields"
                :required="true"
                tabView="tab1"
                )
                e-form-group(
                name="type_id"
                label="Тип"
                inputType="select"
                :options="geoObjectTypes"
                :model="fields"
                :required="true"
                tabView="tab1"
                )
                template(
                v-if="parentItem && parentItems"
                )
                  e-form-group(
                  v-if="parentItemsList.length > 0"
                  name="parent_id"
                  label="Находится в составе"
                  :model="fields"
                  tabView="tab1"
                  inputType="select"
                  :options="parentItemsList"
                  )
                e-form-group(
                name="okato"
                inputType="input"
                validationRule="number"
                label="ОКАТО"
                  :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="oktmo"
                inputType="input"
                validationRule="number"
                label="OKTMO"
                  :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="area"
                inputType="input"
                validationRule="double"
                label="Площадь, кв. м."
                :model="fields"
                tabView="tab1"
                )

              div.col
                div.col-block
                  div.title
                    p {{$translate('Сведения о населении')}}
                  e-form-group(
                  name="year"
                  inputType="select"
                  :options="years"
                  label="Год"
                  :model="currentResidentYear"
                  @change="setCurrentResidents()"
                  tabView="tab1"
                  )
                  e-form-group(
                  v-if="+fields.type_id === 2"
                  name="apartment_building_residence"
                  inputType="input"
                  label="Население, чел"
                  :model="currentResidents"
                  tabView="tab1"
                  validationRule="number"
                  :onChangeValidation="true"
                  )
                  e-form-group(
                  v-if="+fields.type_id !== 2"
                  name="apartment_building_residence"
                  inputType="input"
                  label="Численность в МКД, чел"
                  :model="currentResidents"
                  tabView="tab1"
                  validationRule="number"
                  :onChangeValidation="true"
                  )
                  e-form-group(
                  v-if="+fields.type_id !== 2"
                  name="private_house_residence"
                  inputType="input"
                  label="Численность в ИЖД, чел"
                  :model="currentResidents"
                  tabView="tab1"
                  validationRule="number"
                  :onChangeValidation="true"
                  )


              div.col
                e-form-subtitle(text="Сведения о руководстве")

                e-form-group(
                name="fio"
                inputType="input"
                label="Руководитель"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="phone"
                inputType="input"
                validationRule="phone"
                label="Телефон"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="email"
                inputType="input"
                validationRule="email"
                label="Email"
                :model="fields"
                tabView="tab1"
                )

          div(v-show="tabView === 'garbage-by-action'")
            div.body
              div.col
                e-form-group(
                name="year"
                inputType="select"
                :options="garbageByActionYearsList"
                label="Год"
                tabView="garbage-by-action"
                :model="currentGarbageByAction"
                @change="setCurrentGarbageByActionYear()"
                )

              div.col
              div.col

            div.body
              div.col
                e-table-inner(
                tableWrapperClass="table"
                :visibleColumns="garbageByActionVisibleColumns"
                :itemsEndpoint="endpointGarbageByActionList"
                :showDeleteButton="false"
                :enableInnerPagination="false"
                ref="objectGarbageByAction"
                )

          // вкладка нормативы
          div(v-show="tabView === 'operation'")
            div.body
              div.col
                e-form-subtitle(text="Для многоквартирных домов")
                e-form-group(
                name="mkd_year_meter"
                validateAlias="plan.mkd_year_meter"
                inputType="input"
                validationRule="double"
                label="Норма накопления ТКО, куб.м/чел в год"
                :model="fields.plan"
                tabView="operation"
                :required="!fields.parent_id"
                )
                e-form-group(
                name="mkd_year_kg"
                validateAlias="plan.mkd_year_kg"
                inputType="input"
                validationRule="double"
                label="Норма накопления ТКО кг/чел в год"
                :model="fields.plan"
                tabView="operation"
                :required="!fields.parent_id"
                )
              div.col
                e-form-subtitle(text="Для индивидуального домовладения")

                e-form-group(
                name="village_year_meter"
                validateAlias="plan.village_year_meter"
                inputType="input"
                validationRule="double"
                label="Норма накопления ТКО, куб.м/чел в год"
                :model="fields.plan"
                tabView="operation"
                :required="!fields.parent_id"
                )
                e-form-group(
                name="village_year_kg"
                validateAlias="plan.village_year_kg"
                inputType="input"
                validationRule="double"
                label="Норма накопления ТКО кг/чел в год"
                :model="fields.plan"
                tabView="operation"
                :required="!fields.parent_id"
                )

</template>

<script>
  import {atu, core} from '../../../api/api-endpoints.js'
  import objectForm from '../mixins/object-form.js'

  export default {
    mixins: [objectForm],
    data () {
      return {
        tabView: 'tab1',
        fields: {
          _garbageYear: '',
          parent_id: null,
          name: '',
          okato: '',
          oktmo: '',
          type_id: ''
        },
        errors: null
      }
    },
    computed: {
      tabs () {
        if (!this.fields.parent_id) {
          return [
            {tab1: 'Общие сведения'},
            {'garbage-by-action': 'Отходы'},
            {operation: 'Нормативы'}
          ]
        }
        return [
          {tab1: 'Общие сведения'},
          {operation: 'Нормативы'}
        ]
      }
    },
    methods: {
      prepareFieldsForSend (fields = {}) {
        // for prevent prefix
        delete this.fields.name_with_type
        return fields
      },
      getAtuGarbageByActionMaxMinYearEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return atu.atuGarbageMaxMinYear(route.params.id)
      },
      getUpdateOrCreateUrl () {
        return atu.atuObjectUpdateOrCreate(this.$route.params.id)
      },
      getDeleteUrl (id) {
        return atu.atuObjectDelete(id)
      },
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return atu.atuObject(route.params.id)
      },
      getCollectionEndpoint () {
        return core.collection('geo_object_type')
      },
      getEndpoint (route, fromRoute) {
        return atu.atuObjects(route)
      }
    }
  }
</script>
